import styled from "styled-components";

export const RegisterContainer = styled.div`
  padding: 4rem;
  height: 100%;
  box-sizing: border-box;
`;

export const RegisterCard = styled.div`
  background: #262626;
  padding: 2rem;
  height: 100%;
  box-sizing: border-box;
  border-radius: 1rem;
`;

export const RegisterForm = styled.form`
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const RegisterTitle = styled.p`
  font-size: 1.8rem;
  color: #d9d9d9;
  margin: 1rem 0;
`;
